import _ from 'underscore';
import { IReturnProductType } from '@ve/pages/hotel/types';
import getCriteriaByRoomDate from './getCriteriaByRoomDate';

export default function (products: IReturnProductType[]): IReturnProductType[][] {
    if (!products?.length) return [];

    return _.values(products.reduce((group, product) => {
        const tourKey = getCriteriaByRoomDate(product);

        if (group[`${tourKey}`]) {
            group[`${tourKey}`].push(product);
        } else {
            group[`${tourKey}`] = [product];
        }

        return group;
    }, {} as Record<string, IReturnProductType[]>));
}